import { render } from "./ReferralCode.vue?vue&type=template&id=b0c37f62&scoped=true"
import script from "./ReferralCode.vue?vue&type=script&lang=js"
export * from "./ReferralCode.vue?vue&type=script&lang=js"

import "./ReferralCode.vue?vue&type=style&index=0&id=b0c37f62&scoped=true&lang=css"

import exportComponent from "D:\\vue_referralcode\\referral_code\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0c37f62"]])

export default __exports__